/* Prym Americas - product page shelf pack quantity rules
   Reads pack sizes from window.prymPdpPacks, set in the quantity block. */

(function () {
  'use strict';

  var DATA = window.prymPdpPacks || {};
  var PACKS = DATA.packs || {};                       // { variantId: packSize }
  var DEFAULT_PACK = parseInt(DATA.defaultPack, 10) || 1;
  var NOTE_TEXT = 'Order in increments of ';

  var WRAP_SEL = '[data-prym-qty]';
  var INPUT_SEL = '[data-quantity-input]';
  var NOTE_SEL = '[data-prym-qty-note]';
  var PLUS_CLASS = 'plus_btn';
  var MINUS_CLASS = 'minus_btn';

  function closestEl(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) { return el; }
      el = el.parentNode;
    }
    return null;
  }

  function normalize(value, pack) {
    if (!pack || pack < 1) { pack = 1; }

    var qty = parseInt(value, 10);
    if (isNaN(qty) || qty < pack) { qty = pack; }
    if (pack > 1 && qty % pack !== 0) {
      qty = Math.ceil(qty / pack) * pack;
    }
    return qty;
  }

  function init() {
    var wrap = document.querySelector(WRAP_SEL);
    if (!wrap) { return; }

    var input = wrap.querySelector(INPUT_SEL);
    if (!input) { return; }

    var note = document.querySelector(NOTE_SEL);
    var form = closestEl(wrap, 'form');

    function currentPack() {
      var pack = parseInt(wrap.getAttribute('data-prym-pack'), 10);
      return pack > 0 ? pack : DEFAULT_PACK;
    }

    function setPack(pack) {
      if (!pack || pack < 1) { pack = 1; }

      wrap.setAttribute('data-prym-pack', pack);
      input.setAttribute('min', pack);
      input.setAttribute('step', pack);
      input.value = normalize(input.value, pack);

      if (!note) { return; }
      if (pack > 1) {
        note.textContent = NOTE_TEXT + pack;
        note.removeAttribute('hidden');
      } else {
        note.textContent = '';
        note.setAttribute('hidden', 'hidden');
      }
    }

    function step(direction) {
      var pack = currentPack();
      var current = parseInt(input.value, 10);
      if (isNaN(current)) { current = pack; }

      var next = direction === 'up' ? current + pack : current - pack;
      input.value = normalize(next, pack);
    }

    // take over the theme's plus and minus so they move by the pack size
    wrap.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.classList) { return; }

      var isUp = target.classList.contains(PLUS_CLASS);
      var isDown = target.classList.contains(MINUS_CLASS);
      if (!isUp && !isDown) { return; }

      event.preventDefault();
      event.stopPropagation();
      step(isUp ? 'up' : 'down');
    }, true);

    // round typed values up
    input.addEventListener('change', function () {
      input.value = normalize(input.value, currentPack());
    });

    input.addEventListener('blur', function () {
      input.value = normalize(input.value, currentPack());
    });

    // last check before the line is added to the cart
    if (form) {
      form.addEventListener('submit', function () {
        input.value = normalize(input.value, currentPack());
      }, true);
    }

    // follow variant changes through the hidden id field
    var idInput = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
    if (idInput) {
      var lastId = idInput.value;

      var syncFromId = function () {
        var id = idInput.value;
        if (!id || id === lastId) { return; }
        lastId = id;
        setPack(parseInt(PACKS[id], 10) || DEFAULT_PACK);
      };

      idInput.addEventListener('change', syncFromId);
      if (window.MutationObserver) {
        new MutationObserver(syncFromId).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
      setInterval(syncFromId, 500);
    }

    setPack(currentPack());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();